import { TableCell } from '@mui/material'
import React, { useState } from 'react'
import FormCell from './FormCell'

const FormRow = (props) => {
    const { column, columnIndex, rows, config, errorRef, helperFunction } = props
    const { renderColumns } = config

    const [_, forceRender] = useState({});
    const render = () => forceRender({})

    renderColumns[column?.uniqueName] = render

    const isLock = Object.hasOwn(column, "isReadOnly") ? column?.isReadOnly : false 
    // const isLock = Object.hasOwn(column, "isReadOnly") ? column?.isReadOnly : !!column?.uniqueName ? false : true

    return (
        <>
            <TableCell>
                <FormCell
                    rows={rows}
                    column={column}
                    config={config}
                    columnIndex={columnIndex}
                    errorRef={errorRef}
                    helperFunction={
                        helperFunction
                    }
                    isLock={isLock}
                    // isDisable={ }
                />
            </TableCell>
        </>
    )
}

export default FormRow
